import { render } from "./AddReceiverReportPage.vue?vue&type=template&id=9747dea8&ts=true"
import script from "./AddReceiverReportPage.vue?vue&type=script&lang=ts"
export * from "./AddReceiverReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_Phoi/ZaloOA_Phoi_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__